export class InstallationProductSyncModel {
    public id: number;
    public offerInstallationId: number;
    public productId: number;
    public article: string;
    public quantity: number;
    public price: number;
    public unitId: number;
    public installationProductTypeId: number;
    public articleNumber: string;
    public addedFromPlanner: boolean;
    public discount: number;
    public priceWithoutDiscount: number;
    public billQuantity: number;
}